<template>
  <div class="CarouselGallery" :class="{ vertical: isVertical }">
    <Pic
      v-if="isSinglePhoto"
      alt="Single Photo"
      class="image single-photo"
      loading="lazy"
      :src="images[0].url" />
    <Row v-else>
      <Column :lg="isVertical ? 12 : 8">
        <Hooper class="main-slide" group="group1" :infiniteScroll="true">
          <Slide v-for="image in images" :key="image.id">
            <div>
              <Video
                v-if="image.video_url"
                class="image"
                isExternal
                :src="image.video_url"
                :title="image.name"
                @openVideo="openVideo" />
              <Pic
                v-else
                :alt="image.name"
                class="image"
                loading="lazy"
                :src="image.url" />
            </div>
          </Slide>
          <Navigation slot="hooper-addons">
            <Icon slot="hooper-prev" name="chevron-left" />
            <Icon slot="hooper-next" name="chevron-right" />
          </Navigation>
        </Hooper>
      </Column>
      <Column class="fill" :lg="isVertical ? 12 : 4">
        <Hooper
          class="preview-slides"
          group="group1"
          :infiniteScroll="true"
          :itemsToShow="2"
          :vertical="!isVertical">
          <Slide v-for="image in images" :key="image.id">
            <Pic
              :alt="image.name"
              class="image"
              loading="lazy"
              :src="image.url" />
          </Slide>
        </Hooper>
      </Column>
    </Row>
    <div class="Video">
      <Modal v-if="isVideoOpen" id="Video-iframe" @close="isVideoOpen = false">
        <iframe
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          frameborder="0"
          :height="~~(videoModalWidth / videoModalRatio)"
          :src="`https://www.youtube.com/embed/${videoId}?autoplay=1`"
          :title="portfolioItem.location"
          :width="videoModalWidth" />
      </Modal>
    </div>
  </div>
</template>

<script>
import 'hooper/dist/hooper.css'
import { Hooper, Navigation, Slide } from 'hooper'

export default {
  components: {
    Hooper,
    Navigation,
    Slide,
  },
  props: {
    images: Array,
    isVertical: Boolean,
  },
  data() {
    return {
      isVideoOpen: false,
      videoId: null,
      videoModalWidth: 1,
      videoModalRatio: 16 / 9,
    }
  },
  computed: {
    isSinglePhoto() {
      return (this.images.length === 1)
    },
  },
  methods: {
    openVideo(videoId, width) {
      this.videoId = videoId
      this.videoModalWidth = width
      this.isVideoOpen = !this.isVideoOpen
    },
  },
}
</script>

<style lang="scss">
$color-arrow-overlay: #00000015;

.CarouselGallery {
  .single-photo img {
    max-height: 500px;
    width: 100%;
  }

  .hooper {
    height: auto;
    padding: 0;

    .Icon {
      color: $white;
      font-size: $h3;
    }
  }

  .hooper-prev,
  .hooper-next {
    @include trans;
    background-color: $color-arrow-overlay;
    height: 100%;
    opacity: 0;
    width: 30%;

    &:hover {
      opacity: 1;
    }

    &:focus {
      outline: none;
    }
  }

  .main-slide img {
    display: block;
    height: 360px;
    object-fit: cover;
    width: 100%;
    @include lg {
      min-height: 500px;
    }
  }

  .preview-slides {
    display: none;
    @include lg {
      display: block;
    }

    .hooper-list {
      height: 500px;
    }

    img {
      display: block;
      height: 250px;
      object-fit: cover;
      width: 100%;
    }
  }

  &.vertical {
    .preview-slides {
      .hooper-list {
        height: 200px;
      }

      img {
        height: 100%;
        width: 100%;
      }
    }
  }

  &:not(.vertical) {
    .Column:first-of-type {
      padding-right: 0;
    }
  }
}
</style>
